import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import { reducer as snackReducer } from './slices/snackAlert.js';
import { reducer as logsReducer } from './slices/logs.js';
import { reducer as usersReducer } from './slices/users.js';
import { reducer as respuestasReducer } from './slices/respuestas.js';
import { reducer as masivosReducer } from './slices/masivos.js';
import { reducer as templatesReducer } from './slices/templates.js';
import { reducer as tenantUsersReducer } from './slices/tenantUsers.js';
import { reducer as faqDashboardReducer } from './slices/faqDashboard.js';
import { reducer as surveysReducer } from './slices/surveys.js';

export default function _createStore(services) {
  return createStore(
    combineReducers({
      snack: snackReducer,
      logs: logsReducer,
      users: usersReducer,
      respuestas: respuestasReducer,
      masivos: masivosReducer,
      templates: templatesReducer,
      tenantUsers: tenantUsersReducer,
      faqDashboard: faqDashboardReducer,
      surveys: surveysReducer,
    }),
    applyMiddleware(thunk.withExtraArgument({ services })),
  );
}
